<template><!-- svgo-optimised -->
<svg class="icon icon__minus-new" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg"><path d="M7 9H0" stroke="#090909"/></svg></template>